import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import readyAnimation from '../../static/image/ready.json';
import backgroundAnimation from '../../static/image/background.json';
import fireLottieAnimation from '../../static/image/fireqiangda.json';
import goImage from '../../static/image/go.png';
import pkAvatar from '../../static/image/pk头像.jpg';
import settingsIcon from '../../static/image/设置.png';
import musicIcon from '../../static/image/背景音乐.png';
import restartIcon from '../../static/image/重新开始.png';
import exitIcon from '../../static/image/退出.png';
import exitFishIcon from '../../static/image/退出鱼.png';
import settlementImage from '../../static/image/结算.png';
import crownImage from '../../static/image/皇冠.png';
import retryButtonImage from '../../static/image/再战一次.png';
import completeButtonImage from '../../static/image/完成.png';
import './TestLottie.css';

const RushAnswerGame = () => {
  const navigate = useNavigate();
  const [showBackground, setShowBackground] = useState(false);
  const [isLooping, setIsLooping] = useState(true); // 是否在循环播放前75帧
  const [showFireLottie, setShowFireLottie] = useState(false); // 是否显示 firelottie 动画
  const [fireLottieReloadKey, setFireLottieReloadKey] = useState(0); // 控制 firelottie 重新挂载
  // 从 localStorage 读取音乐状态，默认为 true（开启）
  const [isMusicPlaying, setIsMusicPlaying] = useState(() => {
    const savedMusicState = localStorage.getItem('backgroundMusicEnabled');
    return savedMusicState === null ? true : savedMusicState === 'true';
  });
  const [currentMusicType, setCurrentMusicType] = useState('battleStart'); // 当前音乐类型：'battleStart' 或 'battle'
  const [showSettingsPanel, setShowSettingsPanel] = useState(false); // 是否显示设置面板
  const [showExitDialog, setShowExitDialog] = useState(false); // 是否显示退出弹窗
  const [showQuestions, setShowQuestions] = useState(false); // 是否显示题目
  const [questions, setQuestions] = useState([]); // 题目列表（基础题库）
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0); // 当前题目索引（双方共享）
  const [quizConfig, setQuizConfig] = useState(null); // 比赛配置
  const [leftAnswered, setLeftAnswered] = useState(false); // 左侧选手是否已作答
  const [rightAnswered, setRightAnswered] = useState(false); // 右侧选手是否已作答
  const [leftSelectedOption, setLeftSelectedOption] = useState(null); // 左侧选手已选择的选项
  const [rightSelectedOption, setRightSelectedOption] = useState(null); // 右侧选手已选择的选项
  const [shakingOption, setShakingOption] = useState(null); // 需要抖动的选项 { side: 'left' | 'right', option: string }
  const [leftCompletedCount, setLeftCompletedCount] = useState(0); // 左侧选手已完成题目数
  const [rightCompletedCount, setRightCompletedCount] = useState(0); // 右侧选手已完成题目数
  const [leftScore, setLeftScore] = useState(0); // 左侧选手得分
  const [rightScore, setRightScore] = useState(0); // 右侧选手得分
  const [leftScoreUpdated, setLeftScoreUpdated] = useState(false); // 左侧得分是否刚更新（用于动画）
  const [rightScoreUpdated, setRightScoreUpdated] = useState(false); // 右侧得分是否刚更新（用于动画）
  const [showCompletionDialog, setShowCompletionDialog] = useState(false); // 双方完成提示
  const [showSettlement, setShowSettlement] = useState(false); // 是否显示结算页
  const [leftFinished, setLeftFinished] = useState(false); // 左侧是否全部完成
  const [rightFinished, setRightFinished] = useState(false); // 右侧是否全部完成
  const [windowWidth, setWindowWidth] = useState(window.innerWidth); // 窗口宽度，用于触发字体大小重新计算
  const [startTime, setStartTime] = useState(null); // 开始时间
  const [endTime, setEndTime] = useState(null); // 结束时间
  const [leftEndTime, setLeftEndTime] = useState(null); // 左侧选手完成时间
  const [rightEndTime, setRightEndTime] = useState(null); // 右侧选手完成时间
  const [leftAnswerRecords, setLeftAnswerRecords] = useState([]); // 左侧答题记录 [{questionId, isCorrect}]
  const [rightAnswerRecords, setRightAnswerRecords] = useState([]); // 右侧答题记录 [{questionId, isCorrect}]
  const [leftGotScore, setLeftGotScore] = useState(false); // 左侧是否在当前题目获得分数
  const [rightGotScore, setRightGotScore] = useState(false); // 右侧是否在当前题目获得分数
  const [leftGradientSettings, setLeftGradientSettings] = useState({
    hue: 245,
    saturation: 100,
    topLightness: 81,
    bottomLightness: 42
  });
  const [rightGradientSettings, setRightGradientSettings] = useState({
    hue: 14,
    saturation: 100,
    topLightness: 74,
    bottomLightness: 45
  });
  // 左侧得分和准度的渐变背景设置（固定值）
  const leftStatGradient = {
    r: 22,
    g: 62,
    b: 187,
    opacity: 0.99
  };
  // 右侧得分和准度的渐变背景设置（固定值）
  const rightStatGradient = {
    r: 227,
    g: 75,
    b: 0,
    opacity: 1
  };
  const readyLottieRef = useRef();
  const backgroundLottieRef = useRef();
  const settingsPanelRef = useRef(null); // 设置面板的 DOM 引用
  const hasTriggeredRef = useRef(false); // 防止重复触发
  const loopCheckRef = useRef(false); // 防止重复检查循环
  const readyAudioPlayedRef = useRef(false); // 记录 ready 音频是否已播放
  const goAudioPlayedRef = useRef(false); // 记录 go 音频是否已播放
  const hitAudioPlayedRef = useRef(false); // 记录撞击音频是否已播放
  const backgroundCompleteRef = useRef(false); // 记录background动画是否完成
  const readyAudioRef = useRef(null); // ready 音频对象
  const goAudioRef = useRef(null); // go 音频对象
  const hitAudioRef = useRef(null); // 撞击音频对象
  const correctAudioRef = useRef(null); // 正确音效对象
  const errorAudioRef = useRef(null); // 错误音效对象
  const bgMusicRef = useRef(null); // 背景音乐对象（对战开始背景音乐）
  const battleMusicRef = useRef(null); // 对战背景音乐对象（词汇对决背景音乐）
  const musicInitialized = useRef(false); // 背景音乐是否已初始化
  const showFireLottieRef = useRef(false); // 记录 firelottie 当前显示状态
  const pendingFireLottieReloadRef = useRef(false); // 记录是否需要在下次显示时重载 firelottie
  const leftAnsweringRef = useRef(false); // 左侧是否正在处理答题（同步锁）
  const rightAnsweringRef = useRef(false); // 右侧是否正在处理答题（同步锁）
  const currentQuestionAnsweredCorrectlyRef = useRef(false); // 当前题目是否已经有人答对（抢答赛专用）
  const questionProtectionRef = useRef(false); // 题目保护期标记（防止误触）
  const questionProtectionTimerRef = useRef(null); // 题目保护期定时器
  
  // 听音选图相关
  const questionAudioRef = useRef(null); // 题目音频对象
  const audioRepeatTimerRef = useRef(null); // 音频重复播放定时器
  const audioRepeatCountRef = useRef(0); // 当前音频播放次数
  
  // 重置标记
  const isResettingRef = useRef(false); // 标记是否正在重置，防止useEffect误触发

  // 同步 firelottie 显示状态，并在需要时触发补偿重载
  useEffect(() => {
    showFireLottieRef.current = showFireLottie;
    if (showFireLottie && pendingFireLottieReloadRef.current) {
      pendingFireLottieReloadRef.current = false;
      setFireLottieReloadKey(prev => prev + 1);
    }
  }, [showFireLottie]);

  const reloadFireLottie = useCallback(() => {
    if (showFireLottieRef.current) {
      setFireLottieReloadKey(prev => prev + 1);
    } else {
      pendingFireLottieReloadRef.current = true;
    }
  }, []);

  // 添加页面类名，使用全局背景
  useEffect(() => {
    document.body.classList.add('test-lottie-page');
    
    // 注意：进入全屏已在 Solo 页面点击"开始比赛"时触发
    // 这里不需要再次调用 enterFullscreen()
    
    return () => {
      document.body.classList.remove('test-lottie-page');
    };
  }, []);

  // 根据 showBackground 状态控制左下角底图显示
  useEffect(() => {
    if (showBackground) {
      document.body.classList.add('hide-bottom-left-decoration');
    } else {
      document.body.classList.remove('hide-bottom-left-decoration');
    }
  }, [showBackground]);

  // 点击外部区域关闭设置面板
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showSettingsPanel && settingsPanelRef.current) {
        // 检查点击是否在设置面板或设置按钮外部
        const isClickInsidePanel = settingsPanelRef.current.contains(event.target);
        const isClickOnSettingsButton = event.target.closest('.settings-button-container');
        
        if (!isClickInsidePanel && !isClickOnSettingsButton) {
          setShowSettingsPanel(false);
        }
      }
    };

    if (showSettingsPanel) {
      // 添加延迟，避免立即触发（因为打开面板的点击事件会冒泡）
      setTimeout(() => {
        document.addEventListener('click', handleClickOutside);
      }, 0);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showSettingsPanel]);

  // 初始化音频对象并自动播放
  useEffect(() => {
    readyAudioRef.current = new Audio('/audio/ready.MP3');
    goAudioRef.current = new Audio('/audio/go.MP3');
    hitAudioRef.current = new Audio('/audio/撞击.MP3');
    correctAudioRef.current = new Audio('/audio/正确.MP3');
    errorAudioRef.current = new Audio('/audio/错误.MP3');
    
    // 初始化背景音乐（循环播放）- 对战开始背景音乐
    const bgMusic = new Audio('/audio/对战开始背景音乐.MP3');
    bgMusic.loop = true;
    bgMusic.volume = 0.5;
    bgMusicRef.current = bgMusic;
    
    // 初始化对战背景音乐（循环播放）- 词汇对决背景音乐
    const battleMusic = new Audio('/audio/词汇对决背景音乐.MP3');
    battleMusic.loop = true;
    battleMusic.volume = 0.5;
    battleMusicRef.current = battleMusic;
    
    // 添加音频加载成功监听
    bgMusic.addEventListener('loadeddata', () => {
    });
    
    bgMusic.addEventListener('canplay', () => {
    });
    
    bgMusic.addEventListener('error', (e) => {
    });

    bgMusic.addEventListener('play', () => {
      setIsMusicPlaying(true);
    });

    bgMusic.addEventListener('pause', () => {
    });
    
    // 为对战背景音乐添加播放监听
    battleMusic.addEventListener('play', () => {
      setIsMusicPlaying(true);
    });
    
    // 尝试播放背景音乐的函数
    const tryPlay = () => {
      if (!musicInitialized.current) {
        musicInitialized.current = true;
        
        // 检查用户上次是否关闭了音乐
        const savedMusicState = localStorage.getItem('backgroundMusicEnabled');
        const shouldPlay = savedMusicState === null ? true : savedMusicState === 'true';
        
        if (shouldPlay) {
          bgMusic.play()
            .then(() => {
              setIsMusicPlaying(true);
            })
            .catch(err => {
              musicInitialized.current = false; // 重置，允许用户交互时再次尝试
              setIsMusicPlaying(false);
            });
        } else {
          setIsMusicPlaying(false);
        }
      }
    };

    // 页面任何交互时自动播放（无需用户主动点击播放按钮）
    const handleInteraction = () => {
      if (!musicInitialized.current) {
        tryPlay();
      }
      // 不要移除监听器，因为用户可能暂停后再交互
    };

    // 立即尝试自动播放（可能会被浏览器阻止）
    tryPlay();
    
    // 添加用户交互监听（当自动播放失败时，任何交互都会触发播放）
    document.addEventListener('click', handleInteraction, { passive: true });
    document.addEventListener('touchstart', handleInteraction, { passive: true });
    document.addEventListener('keydown', handleInteraction, { passive: true });
    document.addEventListener('mousemove', handleInteraction, { passive: true, once: true }); // 鼠标移动也算
    
    // 监听全屏状态变化
    const handleFullscreenChange = () => {
      const isFullscreen = Boolean(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
      
      console.log(isFullscreen ? '🔁 进入全屏，重新加载 firelottie' : '🔁 退出全屏，重新加载 firelottie');
      reloadFireLottie();
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);
    
    // 清理音频
    return () => {
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('touchstart', handleInteraction);
      document.removeEventListener('keydown', handleInteraction);
      document.removeEventListener('mousemove', handleInteraction);
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
      
      if (readyAudioRef.current) {
        readyAudioRef.current.pause();
        readyAudioRef.current = null;
      }
      if (goAudioRef.current) {
        goAudioRef.current.pause();
        goAudioRef.current = null;
      }
      if (hitAudioRef.current) {
        hitAudioRef.current.pause();
        hitAudioRef.current = null;
      }
      if (correctAudioRef.current) {
        correctAudioRef.current.pause();
        correctAudioRef.current = null;
      }
      if (errorAudioRef.current) {
        errorAudioRef.current.pause();
        errorAudioRef.current = null;
      }
      if (bgMusicRef.current) {
        bgMusicRef.current.pause();
        bgMusicRef.current = null;
      }
      if (battleMusicRef.current) {
        battleMusicRef.current.pause();
        battleMusicRef.current = null;
      }
    };
  }, [reloadFireLottie]);

  // 监听 ready 动画的每一帧
  const handleEnterFrame = (event) => {
    const currentFrame = event.currentTime;
    
    // 如果在循环阶段（前75帧）
    if (isLooping) {
      // 到达第75帧时，回到第0帧继续循环
      if (currentFrame >= 75 && !loopCheckRef.current) {
        loopCheckRef.current = true;
        if (readyLottieRef.current) {
          readyLottieRef.current.goToAndPlay(0, true);
        }
        // 使用 setTimeout 重置标记，避免立即重复触发
        setTimeout(() => {
          loopCheckRef.current = false;
        }, 50);
      }
      return; // 循环阶段直接返回，避免后续检查
    }
    
    // 以下仅在非循环阶段执行
    
    // 在第75帧播放 ready.mp3
    if (currentFrame >= 75 && !readyAudioPlayedRef.current) {
      readyAudioPlayedRef.current = true;
      if (readyAudioRef.current) {
        readyAudioRef.current.currentTime = 0;
        readyAudioRef.current.play().catch(() => {});
      }
    }
    
    // 在第145帧播放 go.mp3
    if (currentFrame >= 145 && !goAudioPlayedRef.current) {
      goAudioPlayedRef.current = true;
      if (goAudioRef.current) {
        goAudioRef.current.currentTime = 0;
        goAudioRef.current.play().catch(() => {});
      }
    }
    
    // 接近结束时切换到 background（只检查一次）
    if (!hasTriggeredRef.current) {
      const totalFrames = event.totalTime;
      const progress = currentFrame / totalFrames;
      
      if (progress >= 0.99) {
        hasTriggeredRef.current = true;
        setShowBackground(true);
      }
    }
  };

  // 监听 background 动画的每一帧
  const handleBackgroundEnterFrame = (event) => {
    const currentFrame = event.currentTime;
    const totalFrames = event.totalTime;
    
    // 只在需要时检查帧数
    if (!hitAudioPlayedRef.current) {
      // 在第30帧播放撞击音频
      if (currentFrame >= 30) {
        hitAudioPlayedRef.current = true;
        if (hitAudioRef.current) {
          hitAudioRef.current.currentTime = 0;
          hitAudioRef.current.play().catch(() => {});
        }
      }
    }
    
    // 检查动画是否完成（接近结束）
    if (!backgroundCompleteRef.current && totalFrames > 0) {
      const progress = currentFrame / totalFrames;
      if (progress >= 0.99) {
        handleBackgroundComplete();
      }
    }
  };

  // 当 background 动画完成时触发
  const handleBackgroundComplete = () => {
    // 防止重复调用
    if (backgroundCompleteRef.current) {
      return;
    }
    
    // 标记已完成
    backgroundCompleteRef.current = true;
    
    // 从localStorage读取比赛配置
    const savedConfig = localStorage.getItem('quizConfig');
    if (savedConfig) {
      try {
        const config = JSON.parse(savedConfig);
        setQuizConfig(config);
        
        // 生成题目
        const generatedQuestions = generateQuestions(config);
        setQuestions(generatedQuestions);
        // 抢答赛：双方共享同一题目列表
        setCurrentQuestionIndex(0);
        // 重置抢答标记
        currentQuestionAnsweredCorrectlyRef.current = false;
        questionProtectionRef.current = false;
        if (questionProtectionTimerRef.current) {
          clearTimeout(questionProtectionTimerRef.current);
          questionProtectionTimerRef.current = null;
        }
        
        // 预加载第一题和第二题的图片（如果是听音选图）
        if (generatedQuestions.length > 0) {
          // 预加载第一题
          const firstQuestion = generatedQuestions[0];
          if (firstQuestion.type === 'listen-picture' && firstQuestion.options) {
            firstQuestion.options.forEach(imageUrl => {
              if (typeof imageUrl === 'string' && imageUrl) {
                const img = new Image();
                img.src = imageUrl;
              }
            });
          }
          
          // 预加载第二题
          if (generatedQuestions.length > 1) {
            const secondQuestion = generatedQuestions[1];
            if (secondQuestion.type === 'listen-picture' && secondQuestion.options) {
              secondQuestion.options.forEach(imageUrl => {
                if (typeof imageUrl === 'string' && imageUrl) {
                  const img = new Image();
                  img.src = imageUrl;
                }
              });
            }
          }
        }
        
        setLeftCompletedCount(0);
        setRightCompletedCount(0);
        setLeftScore(0);
        setRightScore(0);
        setLeftScoreUpdated(false);
        setRightScoreUpdated(false);
        setLeftGotScore(false);
        setRightGotScore(false);
        setShowCompletionDialog(false);
        setShowSettlement(false); // 关闭结算页
        setLeftFinished(false);
        setRightFinished(false);
        setLeftEndTime(null);
        setRightEndTime(null);
        setStartTime(null);
        setEndTime(null);
        setLeftAnswerRecords([]);
        setRightAnswerRecords([]);
        
        // 延迟显示 firelottie 动画与题目，让背景动画完全结束
        setTimeout(() => {
          setShowQuestions(true);
          setShowFireLottie(true);
          setStartTime(Date.now()); // 记录开始时间
        }, 500);
      } catch (error) {
        // ignore
      }
    } else {
      // ignore
    }
  };

  // 生成题目
  const generateQuestions = (config) => {
    const { questionSource, questionType, questionCount, customWords, availableWords, order } = config;
    
    // 获取题目单词列表
    let words = [];
    if (questionSource === 'custom' && customWords) {
      words = [...customWords];
    } else if (questionSource === 'random' && availableWords) {
      // 随机选择指定数量的单词
      const shuffled = [...availableWords].sort(() => Math.random() - 0.5);
      words = shuffled.slice(0, questionCount);
    }
    
    // 如果是听音选图，过滤掉is_select_picture为false的单词
    if (questionType === 'listen-picture') {
      words = words.filter(word => word.is_select_picture !== false);
    }
    
    if (words.length === 0) {
      return [];
    }
    
    // 根据题目顺序排序
    if (order === 'asc' && availableWords) {
      // 正序：按照单词在原始列表中的顺序
      words.sort((a, b) => {
        const indexA = availableWords.findIndex(w => w.id === a.id);
        const indexB = availableWords.findIndex(w => w.id === b.id);
        return indexA - indexB;
      });
    }
    // random顺序已经在上面随机打乱了
    
    // 获取所有可用单词用于生成错误选项
    const allWordsForOptions = questionSource === 'custom' && customWords 
      ? customWords 
      : (availableWords || []);
    
    // 根据题目类型生成题目
    return words.map((word, index) => {
      let questionData = {};
      
      if (questionType === 'cn-en') {
        // 中译英：显示中文，答案是英文
        questionData = {
          id: index + 1,
          type: 'cn-en',
          question: word.content || '',
          correctAnswer: word.title || '',
          word: word
        };
      } else if (questionType === 'en-cn') {
        // 英译中：显示英文，答案是中文
        questionData = {
          id: index + 1,
          type: 'en-cn',
          question: word.title || '',
          correctAnswer: word.content || '',
          word: word
        };
      } else if (questionType === 'listen-picture') {
        // 听音选图：播放英文发音，选择对应的图片
        const imageUrl = word.images && word.images.length > 0 ? word.images[0].res : '';
        questionData = {
          id: index + 1,
          type: 'listen-picture',
          question: word.title || '', // 英文单词（用于播放音频）
          correctAnswer: imageUrl, // 图片URL
          word: word
        };
      } else {
        // 随机题型：随机选择中译英、英译中或听音选图（在生成时确定，避免每次渲染都变化）
        // 只有有图片和音频的单词才能选听音选图
        const hasImageAndAudio = word.images && word.images.length > 0 && 
                                  (word.audio?.res || word.sounds?.[0]?.res || word.audio);
        
        let randomType;
        if (hasImageAndAudio) {
          // 三种题型随机选一个
          const rand = Math.random();
          if (rand < 0.33) {
            randomType = 'cn-en';
          } else if (rand < 0.66) {
            randomType = 'en-cn';
          } else {
            randomType = 'listen-picture';
          }
        } else {
          // 没有图片或音频，只在中译英和英译中之间随机
          randomType = Math.random() > 0.5 ? 'cn-en' : 'en-cn';
        }
        
        if (randomType === 'listen-picture') {
          const imageUrl = word.images[0].res;
          questionData = {
            id: index + 1,
            type: 'listen-picture',
            question: word.title || '',
            correctAnswer: imageUrl,
            word: word
          };
        } else {
          questionData = {
            id: index + 1,
            type: randomType,
            question: randomType === 'cn-en' ? (word.content || '') : (word.title || ''),
            correctAnswer: randomType === 'cn-en' ? (word.title || '') : (word.content || ''),
            word: word
          };
        }
      }
      
      // 抢答赛：生成同一组选项供双方使用
      const options = generateOptions(questionData, allWordsForOptions);
      questionData.options = options;
      
      // 调试输出：打印每一题的答案、答案对应词的compatible_id以及自身id（统一转字符串）
      // 已移除详细控制台日志
      
      return questionData;
    });
  };

  // 生成选项（1个正确答案 + 3个错误选项）
  const generateOptions = (questionData, allWords) => {
    const { type, correctAnswer, word } = questionData;
    const options = [correctAnswer]; // 先添加正确答案
    
    // 工具函数：将 id/compatible_id 统一处理
    const toIdPair = (w) => {
      const idStr = w?.id != null ? String(w.id) : '';
      const compatRaw = w?.compatible_id ?? w?.compatibleId;
      // 将 compatible_id 转换为数组：支持 "160;169;519"、"160"、null、""
      let compatIds = [];
      if (compatRaw != null && compatRaw !== '') {
        const compatStr = String(compatRaw).trim();
        if (compatStr) {
          compatIds = compatStr.split(';').map(id => id.trim()).filter(id => id);
        }
      }
      return { idStr, compatIds };
    };
    // 判断两个词是否属于同一兼容组（双向兼容也视为同组）
    const isSameCompatGroup = (a, b) => {
      if (!a || !b) return false;
      const { idStr: aId, compatIds: aCompatIds } = toIdPair(a);
      const { idStr: bId, compatIds: bCompatIds } = toIdPair(b);
      
      // 1. 如果 id 相同，认为是同组
      if (aId && bId && aId === bId) return true;
      
      // 2. 检查 a 的 id 是否在 b 的 compatible_id 列表中
      if (aId && bCompatIds.includes(aId)) return true;
      
      // 3. 检查 b 的 id 是否在 a 的 compatible_id 列表中
      if (bId && aCompatIds.includes(bId)) return true;
      
      // 4. 检查两侧的 compatible_id 列表是否有交集
      if (aCompatIds.length > 0 && bCompatIds.length > 0) {
        for (const aCompatId of aCompatIds) {
          if (bCompatIds.includes(aCompatId)) return true;
        }
      }
      
      return false;
    };
    
    // 获取所有可用单词（排除当前单词）
    const availableWords = allWords.filter(w => {
      // 排除与当前词同组的（包含自身与双向兼容）
      if (isSameCompatGroup(w, word)) return false;
      return true;
    });
    
    // 根据题目类型获取错误选项
    const wrongOptions = [];
    const chosenWrongWords = []; // 保存已选择的错误词，确保错误选项之间也不出现同组
    if (type === 'cn-en') {
      // 中译英：错误选项是其他单词的英文
      const shuffled = [...availableWords].sort(() => Math.random() - 0.5);
      for (let i = 0; i < shuffled.length && wrongOptions.length < 3; i++) {
        const candidate = shuffled[i];
        if (!candidate?.title) continue;
        if (candidate.title === correctAnswer) continue;
        // 确保与已选错误词不在同组
        const conflict = chosenWrongWords.some(w => isSameCompatGroup(w, candidate));
        if (conflict) continue;
        wrongOptions.push(candidate.title);
        chosenWrongWords.push(candidate);
      }
    } else if (type === 'listen-picture') {
      // 听音选图：错误选项是其他单词的图片
      // 只从有图片且is_select_picture不为false的单词中选择
      const pictureWords = availableWords.filter(w => 
        w.images && w.images.length > 0 && w.is_select_picture !== false
      );
      const shuffled = [...pictureWords].sort(() => Math.random() - 0.5);
      for (let i = 0; i < shuffled.length && wrongOptions.length < 3; i++) {
        const candidate = shuffled[i];
        const pictureUrl = candidate.images && candidate.images.length > 0 ? candidate.images[0].res : '';
        if (!pictureUrl) continue;
        if (pictureUrl === correctAnswer) continue;
        const conflict = chosenWrongWords.some(w => isSameCompatGroup(w, candidate));
        if (conflict) continue;
        wrongOptions.push(pictureUrl);
        chosenWrongWords.push(candidate);
      }
    } else {
      // 英译中：错误选项是其他单词的中文
      const shuffled = [...availableWords].sort(() => Math.random() - 0.5);
      for (let i = 0; i < shuffled.length && wrongOptions.length < 3; i++) {
        const candidate = shuffled[i];
        if (!candidate?.content) continue;
        if (candidate.content === correctAnswer) continue;
        const conflict = chosenWrongWords.some(w => isSameCompatGroup(w, candidate));
        if (conflict) continue;
        wrongOptions.push(candidate.content);
        chosenWrongWords.push(candidate);
      }
    }
    
    // 如果错误选项不足3个，继续添加
    if (wrongOptions.length < 3 && availableWords.length > 0) {
      const tried = new Set();
      const maxAttempts = Math.max(availableWords.length * 2, 6); // 上限，避免死循环
      let attempts = 0;
      while (wrongOptions.length < 3 && attempts < maxAttempts && tried.size < availableWords.length) {
        attempts++;
        const idx = Math.floor(Math.random() * availableWords.length);
        if (tried.has(idx)) continue;
        tried.add(idx);
        const randomWord = availableWords[idx];
        if (!randomWord) continue;
        const option = type === 'cn-en' ? randomWord?.title : 
                       type === 'listen-picture' ? (randomWord?.picture || randomWord?.image) : 
                       randomWord?.content;
        if (!option) continue;
        const conflictWithCorrect = isSameCompatGroup(randomWord, word);
        const conflictWithChosen = chosenWrongWords.some(w => isSameCompatGroup(w, randomWord));
        if (!conflictWithCorrect && !conflictWithChosen && option !== correctAnswer && !wrongOptions.includes(option)) {
          wrongOptions.push(option);
          chosenWrongWords.push(randomWord);
        }
      }
    }
    
    // 合并正确答案和错误选项，并打乱顺序
    const allOptions = [correctAnswer, ...wrongOptions.slice(0, 3)];
    const shuffledOptions = allOptions.sort(() => Math.random() - 0.5);
    
    // 已移除选项调试日志
    
    return shuffledOptions;
  };

  // 当 ready 动画完成时触发
  const handleReadyComplete = () => {
    // 如果是继续播放阶段完成，切换到 background
    if (!isLooping && !hasTriggeredRef.current) {
      hasTriggeredRef.current = true;
      setShowBackground(true);
    }
  };

  // 点击 GO 按钮，继续播放剩余动画
  const handleGoClick = (e) => {
    e.stopPropagation(); // 阻止事件冒泡
    
    // 继续播放动画（全屏已在页面加载时进入）
    setIsLooping(false); // 停止循环
    if (readyLottieRef.current) {
      // 从第76帧继续播放到结束
      readyLottieRef.current.goToAndPlay(76, true);
    }
    
    // 切换背景音乐：从对战开始背景音乐切换到词汇对决背景音乐
    if (bgMusicRef.current && battleMusicRef.current) {
      const wasPlaying = !bgMusicRef.current.paused;
      
      // 停止对战开始背景音乐
      bgMusicRef.current.pause();
      bgMusicRef.current.currentTime = 0;
      
      // 更新当前音乐类型
      setCurrentMusicType('battle');
      
      // 如果之前正在播放，则播放词汇对决背景音乐
      if (wasPlaying && isMusicPlaying) {
        battleMusicRef.current.currentTime = 0;
        battleMusicRef.current.play()
          .then(() => {
            setIsMusicPlaying(true);
          })
          .catch(err => {
            console.error('切换背景音乐失败:', err);
          });
      }
    }
  };

  // 重置动画 - 回到开始页面，等待用户点击GO按钮
  const handleReset = () => {
    // 标记正在重置，防止useEffect误触发
    isResettingRef.current = true;
    
    hasTriggeredRef.current = false; // 重置触发标记
    loopCheckRef.current = false; // 重置循环检查标记
    readyAudioPlayedRef.current = false; // 重置音频播放标记
    goAudioPlayedRef.current = false; // 重置音频播放标记
    hitAudioPlayedRef.current = false; // 重置撞击音频播放标记
    backgroundCompleteRef.current = false; // 重置background完成标记
    
    // 停止题目音频（听音选图）
    stopQuestionAudio();
    
    // 停止并重置音效（不包括背景音乐）
    if (readyAudioRef.current) {
      readyAudioRef.current.pause();
      readyAudioRef.current.currentTime = 0;
    }
    if (goAudioRef.current) {
      goAudioRef.current.pause();
      goAudioRef.current.currentTime = 0;
    }
    if (hitAudioRef.current) {
      hitAudioRef.current.pause();
      hitAudioRef.current.currentTime = 0;
    }
    if (correctAudioRef.current) {
      correctAudioRef.current.pause();
      correctAudioRef.current.currentTime = 0;
    }
    if (errorAudioRef.current) {
      errorAudioRef.current.pause();
      errorAudioRef.current.currentTime = 0;
    }
    // 重置背景音乐：如果当前播放的是词汇对决背景音乐，切换回对战开始背景音乐
    if (currentMusicType === 'battle' && battleMusicRef.current) {
      const wasPlaying = !battleMusicRef.current.paused;
      battleMusicRef.current.pause();
      battleMusicRef.current.currentTime = 0;
      
      // 更新当前音乐类型
      setCurrentMusicType('battleStart');
      
      // 如果之前正在播放，则播放对战开始背景音乐
      if (wasPlaying && isMusicPlaying && bgMusicRef.current) {
        bgMusicRef.current.currentTime = 0;
        bgMusicRef.current.play()
          .then(() => {
            setIsMusicPlaying(true);
          })
          .catch(err => {
            console.error('重置背景音乐失败:', err);
          });
      }
    } else if (currentMusicType === 'battle') {
      // 即使音乐已暂停，也要重置音乐类型
      setCurrentMusicType('battleStart');
    }
    
    // 立即重置关键状态，防止useEffect误触发
    setShowSettlement(false); // 最先关闭结算页
    setLeftFinished(false);
    setRightFinished(false);
    setShowCompletionDialog(false);
    setShowQuestions(false);
    
    setShowBackground(false);
    setShowFireLottie(false); // 重置 firelottie 显示状态
    setQuestions([]);
    // 抢答赛不需要setQuestionsLeft和setQuestionsRight
    setLeftAnswered(false);
    setRightAnswered(false);
    setLeftSelectedOption(null);
    setRightSelectedOption(null);
    setLeftGotScore(false);
    setRightGotScore(false);
    setShakingOption(null); // 清除抖动状态
    setLeftCompletedCount(0);
    setRightCompletedCount(0);
    setLeftScore(0);
    setRightScore(0);
    setLeftScoreUpdated(false);
    setRightScoreUpdated(false);
    setLeftEndTime(null);
    setRightEndTime(null);
    setStartTime(null); // 重置开始时间
    setEndTime(null); // 重置结束时间
    setLeftAnswerRecords([]); // 重置答题记录
    setRightAnswerRecords([]); // 重置答题记录
    setCurrentQuestionIndex(0); // 重置题目索引
    // 重置抢答相关ref
    leftAnsweringRef.current = false;
    rightAnsweringRef.current = false;
    currentQuestionAnsweredCorrectlyRef.current = false;
    questionProtectionRef.current = false;
    if (questionProtectionTimerRef.current) {
      clearTimeout(questionProtectionTimerRef.current);
      questionProtectionTimerRef.current = null;
    }
    // 设置为循环播放模式，等待用户点击GO按钮
    setIsLooping(true);
    setShowSettingsPanel(false); // 关闭设置面板
    
    // 重新播放 ready 动画（循环模式）
    if (readyLottieRef.current) {
      readyLottieRef.current.goToAndPlay(0);
    }
    // 将background动画停止在第一帧
    if (backgroundLottieRef.current) {
      backgroundLottieRef.current.goToAndStop(0, true);
    }
    
    // 延迟解除重置标记，确保所有状态更新完成
    setTimeout(() => {
      isResettingRef.current = false;
    }, 100);
  };

  // 监听双方完成，直接跳转到结算页
  useEffect(() => {
    // 如果正在重置，不执行任何操作
    if (isResettingRef.current) return;
    
    if (
      showQuestions &&
      leftFinished &&
      rightFinished &&
      !showSettlement  // 防止在已显示结算页时重复触发
    ) {
      // 记录结束时间
      if (startTime && !endTime) {
        setEndTime(Date.now());
      }
      // 直接显示结算页，不显示弹窗
      setShowSettlement(true);
    }
  }, [leftFinished, rightFinished, showQuestions, startTime, endTime, showSettlement]);

  // 对战结束时隐藏 firelottie
  useEffect(() => {
    if (showCompletionDialog || showSettlement) {
      setShowFireLottie(false);
    }
  }, [showCompletionDialog, showSettlement]);

  // 监听窗口大小变化，更新字体大小
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleCloseCompletionDialog = () => {
    setShowCompletionDialog(false);
    // 记录结束时间
    if (startTime && !endTime) {
      setEndTime(Date.now());
    }
    // 关闭弹窗后显示结算页（除非正在重置）
    setTimeout(() => {
      if (!isResettingRef.current) {
        setShowSettlement(true);
      }
    }, 300); // 延迟300ms，让弹窗关闭动画完成
  };

  // 切换音乐播放状态
  const toggleMusic = () => {
    // 根据当前音乐类型选择对应的音乐对象
    const currentMusic = currentMusicType === 'battle' ? battleMusicRef.current : bgMusicRef.current;
    const otherMusic = currentMusicType === 'battle' ? bgMusicRef.current : battleMusicRef.current;
    
    if (currentMusic) {
      if (isMusicPlaying) {
        // 暂停当前音乐并保存状态到 localStorage
        currentMusic.pause();
        // 确保另一个音乐也被暂停（以防万一）
        if (otherMusic) {
          otherMusic.pause();
        }
        setIsMusicPlaying(false);
        localStorage.setItem('backgroundMusicEnabled', 'false');
        console.log('💾 保存音乐状态: 关闭');
      } else {
        // 确保另一个音乐被暂停
        if (otherMusic) {
          otherMusic.pause();
        }
        // 播放当前音乐并保存状态到 localStorage
        currentMusic.currentTime = 0; // 从头开始播放
        currentMusic.play()
          .then(() => {
            setIsMusicPlaying(true);
            localStorage.setItem('backgroundMusicEnabled', 'true');
            console.log('💾 保存音乐状态: 开启');
          })
          .catch(err => console.error('播放失败:', err));
      }
    }
  };

  // 退出全屏模式
  const exitFullscreen = () => {
    try {
      if (document.fullscreenElement || 
          document.webkitFullscreenElement || 
          document.msFullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        console.log('✅ 已退出全屏模式');
      }
    } catch (err) {
      console.warn('⚠️ 退出全屏失败:', err);
    }
  };

  // 点击退出比赛按钮，显示弹窗
  const handleExitClick = () => {
    setShowExitDialog(true);
  };

  // 取消退出
  const handleCancelExit = () => {
    setShowExitDialog(false);
  };

  // 确认退出比赛
  const handleConfirmExit = () => {
    setShowExitDialog(false);
    
    // 先退出全屏
    exitFullscreen();
    
    // 停止所有音频
    if (readyAudioRef.current) readyAudioRef.current.pause();
    if (goAudioRef.current) goAudioRef.current.pause();
    if (hitAudioRef.current) hitAudioRef.current.pause();
    if (correctAudioRef.current) correctAudioRef.current.pause();
    if (errorAudioRef.current) errorAudioRef.current.pause();
    if (bgMusicRef.current) bgMusicRef.current.pause();
    if (battleMusicRef.current) battleMusicRef.current.pause();
    
    console.log('退出比赛，返回词汇对决页面');
    // 跳转到词汇对决（Solo）页面
    navigate('/solo');
  };

  // 格式化时间（毫秒转分秒）
  const formatTime = (milliseconds) => {
    if (!milliseconds) return '00:00';
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  // 判断胜负：分数高获胜，分数相同则准度（正确率）高获胜，准度也相同则平局
  const winner = useMemo(() => {
    if (!leftFinished || !rightFinished || questions.length === 0) return null;
    
    // 计算准确率（包括答对但没得分的题目）
    const leftCorrectCount = leftAnswerRecords.filter(record => record.isCorrect).length;
    const rightCorrectCount = rightAnswerRecords.filter(record => record.isCorrect).length;
    const leftAccuracy = leftCorrectCount / questions.length;
    const rightAccuracy = rightCorrectCount / questions.length;
    
    // 分数高获胜
    if (leftScore > rightScore) return 'left';
    if (rightScore > leftScore) return 'right';
    
    // 分数相同，准确率高获胜
    if (leftAccuracy > rightAccuracy) return 'left';
    if (rightAccuracy > leftAccuracy) return 'right';
    
    // 分数和准确率都相同，平局
    return 'tie';
  }, [leftScore, rightScore, leftFinished, rightFinished, questions.length, leftAnswerRecords, rightAnswerRecords]);

  // 处理完成按钮（退出到solo页面）
  const handleFinish = () => {
    // 先退出全屏
    exitFullscreen();
    
    // 停止所有音频
    if (readyAudioRef.current) readyAudioRef.current.pause();
    if (goAudioRef.current) goAudioRef.current.pause();
    if (hitAudioRef.current) hitAudioRef.current.pause();
    if (correctAudioRef.current) correctAudioRef.current.pause();
    if (errorAudioRef.current) errorAudioRef.current.pause();
    if (bgMusicRef.current) bgMusicRef.current.pause();
    if (battleMusicRef.current) battleMusicRef.current.pause();
    
    // 跳转到词汇对决（Solo）页面
    navigate('/solo');
  };

  // 根据文本长度计算字体大小（字数越多字体越小）
  // 根据屏幕宽度获取字体缩放因子
  const getScreenScaleFactor = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1680) {
      return 1.0; // 1680以上保持当前不变
    } else if (screenWidth >= 1570) {
      return 0.9; // 1570到1680缩小一点
    } else if (screenWidth >= 1440) {
      return 0.84; // 1440到1570缩小到84%
    } else if (screenWidth >= 1350) {
      return 0.8; // 1350到1440再小一点
    } else if (screenWidth >= 1200) {
      return 0.74; // 1200到1350设置为70%
    } else {
      return 0.7; // 1200以下再小一点
    }
  };

  const calculateFontSize = (text) => {
    if (!text) return '36px';
    
    // 计算文本长度（中文字符算1个，英文字符和数字算0.5个）
    const length = text.split('').reduce((sum, char) => {
      // 中文字符、中文标点等
      if (/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/.test(char)) {
        return sum + 1;
      }
      // 英文字符、数字、英文标点等
      return sum + 0.5;
    }, 0);
    
    // 根据长度计算字体大小
    // 长度 <= 10: 36px
    // 长度 10-20: 36px 到 28px 线性递减
    // 长度 20-30: 28px 到 22px 线性递减
    // 长度 > 30: 22px 到 16px 线性递减
    let fontSize;
    if (length <= 10) {
      fontSize = 36;
    } else if (length <= 20) {
      fontSize = 36 - (length - 10) * 0.8; // 36 -> 28
    } else if (length <= 30) {
      fontSize = 28 - (length - 20) * 0.6; // 28 -> 22
    } else {
      fontSize = Math.max(16, 22 - (length - 30) * 0.2); // 22 -> 16，最小16px
    }
    
    // 根据屏幕宽度应用缩放因子
    const scaleFactor = getScreenScaleFactor();
    fontSize = fontSize * scaleFactor;
    
    return `${Math.round(fontSize)}px`;
  };

  // 根据文本长度计算选项按钮的字体大小
  const calculateOptionFontSize = (text) => {
    if (!text) return '58px';
    
    // 计算文本长度（中文字符算1个，英文字符和数字算0.5个）
    const length = text.split('').reduce((sum, char) => {
      // 中文字符、中文标点等
      if (/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/.test(char)) {
        return sum + 1;
      }
      // 英文字符、数字、英文标点等
      return sum + 0.5;
    }, 0);
    
    // 根据长度计算字体大小
    // 长度 < 2: 58px
    // 长度 < 4: 44px
    // 长度 < 8: 32px
    // 长度 < 15: 24px
    // 其他: 18px
    let fontSize;
    if (length < 3) {
      fontSize = 56;
    } else if (length < 4) {
      fontSize = 52;
    } else if (length < 5) {
      fontSize = 48;
    }else if (length < 6) {
      fontSize = 46;
    } else if (length < 7) {
      fontSize = 44;
    } else if (length < 8) {
      fontSize = 42;
    } else if (length < 9) {
      fontSize = 40;
    } else if (length < 10) {
      fontSize = 38;
    } else if (length < 11) {
      fontSize = 34;
    } else {
      fontSize = 24;
    }
    
    // 根据屏幕宽度应用缩放因子
    const scaleFactor = getScreenScaleFactor();
    fontSize = fontSize * scaleFactor;
    
    return `${Math.round(fontSize)}px`;
  };

  const getGradientTokens = (hue, settings) => {
    const { saturation, topLightness, bottomLightness } = settings;
    const topColor = `hsl(${hue}, ${saturation}%, ${topLightness}%)`;
    const bottomColor = `hsl(${hue}, ${saturation}%, ${bottomLightness}%)`;
    const borderColor = `hsla(${hue}, ${Math.min(100, saturation + 4)}%, ${Math.max(bottomLightness - 6, 10)}%, 0.9)`;
    const shadowColor = `hsla(${hue}, ${Math.max(30, saturation - 10)}%, ${Math.max(bottomLightness - 12, 6)}%, 0.55)`;
    return {
      topColor,
      bottomColor,
      borderColor,
      shadowColor
    };
  };

  const leftGradientColors = useMemo(() => getGradientTokens(leftGradientSettings.hue, leftGradientSettings), [leftGradientSettings]);
  const rightGradientColors = useMemo(() => getGradientTokens(rightGradientSettings.hue, rightGradientSettings), [rightGradientSettings]);
  
  // 进度条渐变颜色（固定值：左侧蓝色，右侧红色）
  const leftProgressGradientColors = {
    topColor: 'hsl(245, 100%, 75%)',
    bottomColor: 'hsl(245, 100%, 46%)'
  };
  const rightProgressGradientColors = {
    topColor: 'hsl(20, 100%, 74%)',
    bottomColor: 'hsl(20, 100%, 45%)'
  };

  // 停止当前题目音频播放
  const stopQuestionAudio = () => {
    if (questionAudioRef.current) {
      questionAudioRef.current.pause();
      questionAudioRef.current.currentTime = 0;
      questionAudioRef.current = null;
    }
    if (audioRepeatTimerRef.current) {
      clearTimeout(audioRepeatTimerRef.current);
      audioRepeatTimerRef.current = null;
    }
    audioRepeatCountRef.current = 0;
  };

  // 播放题目音频（听音选图模式）
  const playQuestionAudio = (audioUrl) => {
    if (!audioUrl) return;
    
    // 先停止之前的音频
    stopQuestionAudio();
    
    audioRepeatCountRef.current = 0;
    
    const playOnce = () => {
      if (audioRepeatCountRef.current >= 3) return; // 最多播放3次
      
      const audio = new Audio(audioUrl);
      questionAudioRef.current = audio;
      
      audio.addEventListener('ended', () => {
        audioRepeatCountRef.current++;
        questionAudioRef.current = null;
        
        // 如果还没播放够3次，1秒后播放下一次
        if (audioRepeatCountRef.current < 3) {
          audioRepeatTimerRef.current = setTimeout(() => {
            playOnce();
          }, 1000);
        }
      });
      
      audio.addEventListener('error', () => {
        console.error('音频播放失败');
        questionAudioRef.current = null;
      });
      
      audio.play().catch(error => {
        console.error('播放音频失败:', error);
      });
    };
    
    playOnce();
  };

  // 处理选项点击 - 抢答赛逻辑（支持触屏和鼠标）
  const handleOptionClick = (option, side, event) => {
    // 阻止默认行为和事件冒泡
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    // 题目保护期内禁止点击（防止误触）
    if (questionProtectionRef.current) {
      return;
    }
    
    // 使用ref实现同步锁，防止重复点击
    if (side === 'left') {
      if (leftAnsweringRef.current || leftAnswered) return;
      leftAnsweringRef.current = true;
    } else {
      if (rightAnsweringRef.current || rightAnswered) return;
      rightAnsweringRef.current = true;
    }
    
    const currentQuestion = questions[currentQuestionIndex];
    if (!currentQuestion) {
      if (side === 'left') leftAnsweringRef.current = false;
      else rightAnsweringRef.current = false;
      return;
    }
    
    // 判断答案是否正确
    const isCorrect = option === currentQuestion.correctAnswer;
    
    if (side === 'left') {
      // 立即标记左侧已作答，防止重复点击
      setLeftAnswered(true);
      setLeftSelectedOption(option);
      
      if (isCorrect) {
        // 检查是否是第一个答对的（抢答赛核心逻辑）
        const isFirstCorrect = !currentQuestionAnsweredCorrectlyRef.current;
        
        // 记录左侧答题情况（包括是否得分）
        setLeftAnswerRecords(prev => [...prev, {
          questionId: currentQuestion.id,
          question: currentQuestion,
          isCorrect: isCorrect,
          gotScore: isFirstCorrect  // 是否得分
        }]);
        
        if (isFirstCorrect) {
          // 标记当前题目已被答对
          currentQuestionAnsweredCorrectlyRef.current = true;
          
          // 标记左侧获得了分数
          setLeftGotScore(true);
          
          // 只有第一个答对的人加分
          setLeftScore(prev => prev + 1);
          setLeftScoreUpdated(true);
          setTimeout(() => setLeftScoreUpdated(false), 500);
          setLeftCompletedCount(prev => prev + 1);
          
          // 播放正确音效
          if (correctAudioRef.current) {
            correctAudioRef.current.currentTime = 0;
            correctAudioRef.current.play().catch(error => {
              console.error('播放正确音效失败:', error);
            });
          }
        } else {
          // 虽然答对了，但不是第一个，不加分，但播放正确音效
          if (correctAudioRef.current) {
            correctAudioRef.current.currentTime = 0;
            correctAudioRef.current.play().catch(error => {
              console.error('播放正确音效失败:', error);
            });
          }
        }
      } else {
        // 记录左侧答题情况（答错）
        setLeftAnswerRecords(prev => [...prev, {
          questionId: currentQuestion.id,
          question: currentQuestion,
          isCorrect: false,
          gotScore: false
        }]);
        
        // 播放错误音效
        if (errorAudioRef.current) {
          errorAudioRef.current.currentTime = 0;
          errorAudioRef.current.play().catch(error => {
            console.error('播放错误音效失败:', error);
          });
        }
        // 触发错误选项抖动
        setShakingOption({ side: 'left', option });
        setTimeout(() => {
          setShakingOption(null);
        }, 600);
      }
    } else {
      // 立即标记右侧已作答，防止重复点击
      setRightAnswered(true);
      setRightSelectedOption(option);
      
      if (isCorrect) {
        // 检查是否是第一个答对的（抢答赛核心逻辑）
        const isFirstCorrect = !currentQuestionAnsweredCorrectlyRef.current;
        
        // 记录右侧答题情况（包括是否得分）
        setRightAnswerRecords(prev => [...prev, {
          questionId: currentQuestion.id,
          question: currentQuestion,
          isCorrect: isCorrect,
          gotScore: isFirstCorrect  // 是否得分
        }]);
        
        if (isFirstCorrect) {
          // 标记当前题目已被答对
          currentQuestionAnsweredCorrectlyRef.current = true;
          
          // 标记右侧获得了分数
          setRightGotScore(true);
          
          // 只有第一个答对的人加分
          setRightScore(prev => prev + 1);
          setRightScoreUpdated(true);
          setTimeout(() => setRightScoreUpdated(false), 500);
          setRightCompletedCount(prev => prev + 1);
          
          // 播放正确音效
          if (correctAudioRef.current) {
            correctAudioRef.current.currentTime = 0;
            correctAudioRef.current.play().catch(error => {
              console.error('播放正确音效失败:', error);
            });
          }
        } else {
          // 虽然答对了，但不是第一个，不加分，但播放正确音效
          if (correctAudioRef.current) {
            correctAudioRef.current.currentTime = 0;
            correctAudioRef.current.play().catch(error => {
              console.error('播放正确音效失败:', error);
            });
          }
        }
      } else {
        // 记录右侧答题情况（答错）
        setRightAnswerRecords(prev => [...prev, {
          questionId: currentQuestion.id,
          question: currentQuestion,
          isCorrect: false,
          gotScore: false
        }]);
        
        // 播放错误音效
        if (errorAudioRef.current) {
          errorAudioRef.current.currentTime = 0;
          errorAudioRef.current.play().catch(error => {
            console.error('播放错误音效失败:', error);
          });
        }
        // 触发错误选项抖动
        setShakingOption({ side: 'right', option });
        setTimeout(() => {
          setShakingOption(null);
        }, 600);
      }
    }
  };
  
  // 监听题目变化，播放听音选图音频并预加载图片
  useEffect(() => {
    if (!showQuestions || currentQuestionIndex >= questions.length) return;
    
    const currentQuestion = questions[currentQuestionIndex];
    if (!currentQuestion) return;
    
    // 设置题目保护期（0.5秒内禁止点击，防止误触）
    questionProtectionRef.current = true;
    if (questionProtectionTimerRef.current) {
      clearTimeout(questionProtectionTimerRef.current);
    }
    questionProtectionTimerRef.current = setTimeout(() => {
      questionProtectionRef.current = false;
    }, 500);
    
    // 首先停止之前可能正在播放的音频
    stopQuestionAudio();
    
    // 预加载当前题目的图片（如果是听音选图）
    if (currentQuestion.type === 'listen-picture' && currentQuestion.options) {
      currentQuestion.options.forEach(imageUrl => {
        if (typeof imageUrl === 'string' && imageUrl) {
          const img = new Image();
          img.src = imageUrl;
        }
      });
    }
    
    // 如果是听音选图模式，播放音频
    if (currentQuestion.type === 'listen-picture' && currentQuestion.word) {
      const word = currentQuestion.word;
      const audioUrl = word.audio?.res || word.sounds?.[0]?.res || word.audio || '';
      if (audioUrl) {
        // 延迟一点播放，确保UI已经渲染
        setTimeout(() => {
          playQuestionAudio(audioUrl);
        }, 300);
      }
    }
    
    // 同时预加载下一题的图片（如果是听音选图模式）
    if (currentQuestionIndex < questions.length - 1) {
      const nextQuestion = questions[currentQuestionIndex + 1];
      if (nextQuestion && nextQuestion.type === 'listen-picture' && nextQuestion.options) {
        nextQuestion.options.forEach(imageUrl => {
          if (typeof imageUrl === 'string' && imageUrl) {
            const img = new Image();
            img.src = imageUrl;
          }
        });
      }
    }
    
    // 清理函数：组件卸载或题目切换时停止音频和清除保护期定时器
    return () => {
      stopQuestionAudio();
      if (questionProtectionTimerRef.current) {
        clearTimeout(questionProtectionTimerRef.current);
      }
    };
  }, [currentQuestionIndex, showQuestions, questions]);

  // 监听双方作答状态，判断是否进入下一题
  useEffect(() => {
    if (!showQuestions || currentQuestionIndex >= questions.length) return;
    
    const currentQuestion = questions[currentQuestionIndex];
    if (!currentQuestion) return;
    
    const leftCorrect = leftAnswered && leftSelectedOption === currentQuestion.correctAnswer;
    const rightCorrect = rightAnswered && rightSelectedOption === currentQuestion.correctAnswer;
    
    // 判断是否需要进入下一题：
    // 1. 任一方答对
    // 2. 双方都已作答
    const shouldMoveNext = leftCorrect || rightCorrect || (leftAnswered && rightAnswered);
    
    if (shouldMoveNext) {
      // 延迟500ms后进入下一题
      const timer = setTimeout(() => {
        // 重置锁
        leftAnsweringRef.current = false;
        rightAnsweringRef.current = false;
        // 重置抢答标记
        currentQuestionAnsweredCorrectlyRef.current = false;
        
        if (currentQuestionIndex < questions.length - 1) {
          // 停止当前题目音频
          stopQuestionAudio();
          
          // 进入下一题
          setCurrentQuestionIndex(prev => prev + 1);
          setLeftAnswered(false);
          setRightAnswered(false);
          setLeftSelectedOption(null);
          setRightSelectedOption(null);
          setLeftGotScore(false);
          setRightGotScore(false);
        } else {
          // 停止当前题目音频
          stopQuestionAudio();
          // 所有题目完成
          setLeftFinished(true);
          setRightFinished(true);
          if (!leftEndTime) setLeftEndTime(Date.now());
          if (!rightEndTime) setRightEndTime(Date.now());
        }
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, [leftAnswered, rightAnswered, leftSelectedOption, rightSelectedOption, currentQuestionIndex, questions, showQuestions, leftEndTime, rightEndTime]);

  useEffect(() => {
    if (!showSettlement) {
      return;
    }

    const containers = Array.from(document.querySelectorAll('.settlement-records-scroll'));
    if (containers.length === 0) {
      return;
    }

    const timeouts = new Map();

    const handleScroll = (event) => {
      const element = event.currentTarget;
      if (!element) return;

      element.classList.add('show-scrollbar');

      if (timeouts.has(element)) {
        clearTimeout(timeouts.get(element));
      }

      const timer = setTimeout(() => {
        element.classList.remove('show-scrollbar');
        timeouts.delete(element);
      }, 900);

      timeouts.set(element, timer);
    };

    containers.forEach((element) => {
      element.classList.remove('show-scrollbar');
      element.addEventListener('scroll', handleScroll, { passive: true });
    });

    return () => {
      containers.forEach((element) => {
        element.removeEventListener('scroll', handleScroll);
        element.classList.remove('show-scrollbar');
      });

      timeouts.forEach((timer) => clearTimeout(timer));
      timeouts.clear();
    };
  }, [showSettlement, leftAnswerRecords.length, rightAnswerRecords.length]);

  return (
    <div className="fullpage-animation-container">
      {/* 全屏动画区域 */}
      {!showBackground ? (
        <div className="fullpage-animation-wrapper ready-animation">
          <Lottie 
            lottieRef={readyLottieRef}
            animationData={readyAnimation} 
            loop={isLooping}
            autoplay={true}
            onEnterFrame={handleEnterFrame}
            onComplete={handleReadyComplete}
            renderer="canvas"
            rendererSettings={{
              preserveAspectRatio: 'xMidYMid meet',
              progressiveLoad: true,
              hideOnTransparent: true,
              clearCanvas: true,
              context: null,
              imagePreserveAspectRatio: 'xMidYMid slice'
            }}
          />
          
          {/* GO 按钮 - 在循环播放时一直显示 */}
          {isLooping && (
            <img 
              src={goImage} 
              alt="GO" 
              className="go-button-overlay"
              onClick={handleGoClick}
            />
          )}
        </div>
      ) : (
        <>
          <div className="fullpage-animation-wrapper background-animation">
            <Lottie 
              lottieRef={backgroundLottieRef}
              animationData={backgroundAnimation} 
              loop={false}
              autoplay={true}
              onEnterFrame={handleBackgroundEnterFrame}
              onComplete={handleBackgroundComplete}
              renderer="canvas"
              style={{ width: '100%', height: '100%' }}
              rendererSettings={{
                preserveAspectRatio: 'xMidYMax slice',
                clearCanvas: true,
                progressiveLoad: true,
                hideOnTransparent: true
              }}
            />
          </div>
          
          {/* FireLottie 动画 - 在background播放完成后显示，带下落动画 */}
          {showFireLottie && (
            <div className="fire-lottie-container" key={fireLottieReloadKey}>
              <Lottie
                animationData={fireLottieAnimation}
                loop={true}
                autoplay={true}
                style={{ width: '100%', height: '100%' }}
                renderer="canvas"
                rendererSettings={{
                  preserveAspectRatio: 'xMidYMid meet',
                  progressiveLoad: true,
                  hideOnTransparent: true
                }}
              />
            </div>
          )}
          
          
          {/* 题目显示区域 - 在background动画完成后显示，结算页时隐藏 */}
          {showQuestions && !showSettlement && questions.length > 0 && (
            <>
              {/* 左侧得分显示 - 独立于进度条，避免 transform 影响定位 */}
              <div
                className="quiz-score-left"
                style={{
                  background: `linear-gradient(180deg, ${leftGradientColors.topColor}, ${leftGradientColors.bottomColor})`,
                  borderColor: leftGradientColors.borderColor,
                  boxShadow: `0 0.8vh 2vh ${leftGradientColors.shadowColor}`
                }}
              >
                <div className={`quiz-score-value ${leftScoreUpdated ? 'score-updated' : ''}`}>{leftScore}分</div>
                <div className="quiz-score-label">得分</div>
              </div>

              {/* 左侧进度条 - 始终显示，直到所有题目完成 */}
              <div className="quiz-progress-left">
                <div className="quiz-progress-content">
                  {/* 头像 */}
                  <div className="quiz-progress-avatar">
                    <img src={pkAvatar} alt="选手1头像" className="quiz-progress-avatar-image" />
                  </div>
                  {/* 进度条区域 */}
                  <div className="quiz-progress-bar-wrapper">
                    <div className="quiz-progress-bar-container">
                      <div 
                        className="quiz-progress-bar-fill"
                        style={{ 
                          width: `${((currentQuestionIndex) / (questions.length || 1)) * 100}%`,
                          background: `linear-gradient(180deg, ${leftProgressGradientColors.topColor}, ${leftProgressGradientColors.bottomColor})`
                        }}
                      />
                      <div className="quiz-progress-text">
                        {currentQuestionIndex + 1} / {questions.length}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* 右侧进度条 - 始终显示，直到所有题目完成 */}
              <div className="quiz-progress-right">
                <div className="quiz-progress-content">
                  {/* 进度条区域 */}
                  <div className="quiz-progress-bar-wrapper">
                    <div className="quiz-progress-bar-container">
                      <div 
                        className="quiz-progress-bar-fill"
                        style={{ 
                          width: `${((currentQuestionIndex) / (questions.length || 1)) * 100}%`,
                          background: `linear-gradient(180deg, ${rightProgressGradientColors.topColor}, ${rightProgressGradientColors.bottomColor})`
                        }}
                      />
                      <div className="quiz-progress-text">
                        {currentQuestionIndex + 1} / {questions.length}
                      </div>
                    </div>
                  </div>
                  {/* 头像 */}
                  <div className="quiz-progress-avatar">
                    <img src={pkAvatar} alt="选手2头像" className="quiz-progress-avatar-image" />
                  </div>
                </div>
              </div>

              {/* 右侧得分显示 - 独立于进度条，避免 transform 影响定位 */}
              <div
                className="quiz-score-right"
                style={{
                  background: `linear-gradient(180deg, ${rightGradientColors.topColor}, ${rightGradientColors.bottomColor})`,
                  borderColor: rightGradientColors.borderColor,
                  boxShadow: `0 0.8vh 2vh ${rightGradientColors.shadowColor}`
                }}
              >
                <div className={`quiz-score-value ${rightScoreUpdated ? 'score-updated' : ''}`}>{rightScore}分</div>
                <div className="quiz-score-label">得分</div>
              </div>
              
              <div className="quiz-questions-container">
                {/* 左侧选手 */}
                {currentQuestionIndex < questions.length && (
                  <div className="quiz-question-left">
                    <div className="quiz-question-card">
                      {/* 题目区域 */}
                      {questions[currentQuestionIndex]?.type === 'listen-picture' ? (
                        <div className="quiz-audio-wave-container">
                          <div className="audio-wave">
                            <div className="wave-bar"></div>
                            <div className="wave-bar"></div>
                            <div className="wave-bar"></div>
                            <div className="wave-bar"></div>
                            <div className="wave-bar"></div>
                          </div>
                        </div>
                      ) : (
                        <div 
                          className="quiz-question-text chinese-text"
                          style={{ 
                            fontSize: calculateFontSize(questions[currentQuestionIndex]?.question)
                          }}
                        >
                          {questions[currentQuestionIndex]?.question}
                        </div>
                      )}
                      
                      {/* 选项区域 */}
                      <div className={`quiz-options-container ${questions[currentQuestionIndex]?.type === 'listen-picture' ? 'picture-grid' : ''}`}>
                        {questions[currentQuestionIndex]?.options?.map((option, index) => {
                          const isListenPicture = questions[currentQuestionIndex]?.type === 'listen-picture';
                          const isCorrectAnswer = isListenPicture 
                            ? option === questions[currentQuestionIndex]?.correctAnswer 
                            : option === questions[currentQuestionIndex]?.correctAnswer;
                          const isSelected = isListenPicture 
                            ? leftSelectedOption === option 
                            : leftSelectedOption === option;
                          // 只有获得分数时才显示正确样式
                          const showCorrect = leftAnswered && isSelected && isCorrectAnswer && leftGotScore;
                          const showWrong = leftAnswered && isSelected && !isCorrectAnswer;
                          const isShaking = shakingOption?.side === 'left' && shakingOption?.option === option;
                          
                          if (isListenPicture) {
                            return (
                              <div
                                key={index}
                                className={`quiz-picture-option ${leftAnswered ? 'answered' : ''} ${showCorrect ? 'correct' : ''} ${showWrong ? 'wrong' : ''} ${isShaking ? 'shake' : ''}`}
                                onTouchStart={(e) => !leftAnswered && handleOptionClick(option, 'left', e)}
                                onClick={(e) => !leftAnswered && handleOptionClick(option, 'left', e)}
                              >
                                <img src={option} alt="选项图片" />
                              </div>
                            );
                          }
                          
                          return (
                            <button
                              key={index}
                              className={`quiz-option ${leftAnswered ? 'answered' : ''} ${showCorrect ? 'correct' : ''} ${showWrong ? 'wrong' : ''} ${isShaking ? 'shake' : ''}`}
                              onTouchStart={(e) => !leftAnswered && handleOptionClick(option, 'left', e)}
                              onClick={(e) => !leftAnswered && handleOptionClick(option, 'left', e)}
                              disabled={leftAnswered}
                              style={{ fontSize: calculateOptionFontSize(option) }}
                            >
                              {option}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}
                {currentQuestionIndex >= questions.length && (
                  <div className="quiz-question-left">
                    <div className="quiz-finished-card">
                      <div className="quiz-finished-banner left-finished">
                        <div className="finished-icon">✓</div>
                        <div className="finished-text">
                          <div className="finished-team-name">大鱼先锋队</div>
                          <div className="finished-status">已作答完毕</div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                
                {/* 右侧选手 */}
                {currentQuestionIndex < questions.length && (
                  <div className="quiz-question-right">
                    <div className="quiz-question-card">
                      {/* 题目区域 */}
                      {questions[currentQuestionIndex]?.type === 'listen-picture' ? (
                        <div className="quiz-audio-wave-container">
                          <div className="audio-wave">
                            <div className="wave-bar"></div>
                            <div className="wave-bar"></div>
                            <div className="wave-bar"></div>
                            <div className="wave-bar"></div>
                            <div className="wave-bar"></div>
                          </div>
                        </div>
                      ) : (
                        <div 
                          className="quiz-question-text chinese-text"
                          style={{ 
                            fontSize: calculateFontSize(questions[currentQuestionIndex]?.question)
                          }}
                        >
                          {questions[currentQuestionIndex]?.question}
                        </div>
                      )}
                      
                      {/* 选项区域 */}
                      <div className={`quiz-options-container ${questions[currentQuestionIndex]?.type === 'listen-picture' ? 'picture-grid' : ''}`}>
                        {questions[currentQuestionIndex]?.options?.map((option, index) => {
                          const isListenPicture = questions[currentQuestionIndex]?.type === 'listen-picture';
                          const isCorrectAnswer = isListenPicture 
                            ? option === questions[currentQuestionIndex]?.correctAnswer 
                            : option === questions[currentQuestionIndex]?.correctAnswer;
                          const isSelected = isListenPicture 
                            ? rightSelectedOption === option 
                            : rightSelectedOption === option;
                          // 只有获得分数时才显示正确样式
                          const showCorrect = rightAnswered && isSelected && isCorrectAnswer && rightGotScore;
                          const showWrong = rightAnswered && isSelected && !isCorrectAnswer;
                          const isShaking = shakingOption?.side === 'right' && shakingOption?.option === option;
                          
                          if (isListenPicture) {
                            return (
                              <div
                                key={index}
                                className={`quiz-picture-option ${rightAnswered ? 'answered' : ''} ${showCorrect ? 'correct' : ''} ${showWrong ? 'wrong' : ''} ${isShaking ? 'shake' : ''}`}
                                onTouchStart={(e) => !rightAnswered && handleOptionClick(option, 'right', e)}
                                onClick={(e) => !rightAnswered && handleOptionClick(option, 'right', e)}
                              >
                                <img src={option} alt="选项图片" />
                              </div>
                            );
                          }
                          
                          return (
                            <button
                              key={index}
                              className={`quiz-option ${rightAnswered ? 'answered' : ''} ${showCorrect ? 'correct' : ''} ${showWrong ? 'wrong' : ''} ${isShaking ? 'shake' : ''}`}
                              onTouchStart={(e) => !rightAnswered && handleOptionClick(option, 'right', e)}
                              onClick={(e) => !rightAnswered && handleOptionClick(option, 'right', e)}
                              disabled={rightAnswered}
                              style={{ fontSize: calculateOptionFontSize(option) }}
                            >
                              {option}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}
                {currentQuestionIndex >= questions.length && (
                  <div className="quiz-question-right">
                    <div className="quiz-finished-card">
                      <div className="quiz-finished-banner right-finished">
                        <div className="finished-icon">✓</div>
                        <div className="finished-text">
                          <div className="finished-team-name">大鱼破浪队</div>
                          <div className="finished-status">已作答完毕</div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

            </>
          )}
        </>
      )}


      {/* 设置按钮和设置面板 - 结算页时隐藏 */}
      {!showSettlement && (
        <>
          <div className="settings-button-container">
            <img 
              src={settingsIcon} 
              alt="设置" 
              className="settings-icon"
              onClick={() => setShowSettingsPanel(!showSettingsPanel)}
            />
          </div>
          
          {/* 设置面板 - 从设置按钮向右延伸形成胶囊 */}
          <div 
            ref={settingsPanelRef} 
            className={`settings-panel ${showSettingsPanel ? 'show' : ''}`}
            style={{
              '--settings-scale': getScreenScaleFactor()
            }}
          >
            {/* 音乐开关 */}
            <div className="settings-item" onClick={toggleMusic}>
              <div className={`settings-icon-img ${isMusicPlaying ? 'music-on' : 'music-off'}`}>
                <img src={musicIcon} alt="背景音乐" />
              </div>
              <span className="settings-label">{isMusicPlaying ? '背景音乐' : '背景音乐'}</span>
            </div>
            
            {/* 重新比赛 */}
            <div className="settings-item" onClick={handleReset}>
              <div className="settings-icon-img restart-icon">
                <img src={restartIcon} alt="重新比赛" />
              </div>
              <span className="settings-label">重新比赛</span>
            </div>
            
            {/* 退出比赛 */}
            <div className="settings-item" onClick={handleExitClick}>
              <div className="settings-icon-img exit-icon">
                <img src={exitIcon} alt="退出比赛" />
              </div>
              <span className="settings-label">退出比赛</span>
            </div>
          </div>
        </>
      )}

      {/* 退出弹窗 */}
      {showExitDialog && (
        <div className="exit-dialog-overlay" onClick={handleCancelExit}>
          <div className="exit-dialog" onClick={(e) => e.stopPropagation()}>
            <img src={exitFishIcon} alt="退出鱼" className="exit-fish-icon" />
            <p className="exit-dialog-title">PK还没有结束哦</p>
            <p className="exit-dialog-text">确定要退出吗？</p>
            <div className="exit-dialog-buttons">
              <button className="exit-dialog-btn cancel-btn" onClick={handleCancelExit}>
                取消
              </button>
              <button className="exit-dialog-btn confirm-btn" onClick={handleConfirmExit}>
                确定
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 作答完毕弹窗 */}
      {showCompletionDialog && (
        <div className="exit-dialog-overlay" onClick={handleCloseCompletionDialog}>
          <div className="exit-dialog" onClick={(e) => e.stopPropagation()}>
            <img src={exitFishIcon} alt="完成鱼" className="exit-fish-icon" />
            <p className="exit-dialog-title">作答完毕</p>
            <p className="exit-dialog-text">双方已完成全部题目</p>
            <div className="exit-dialog-buttons">
              <button className="exit-dialog-btn confirm-btn" onClick={handleCloseCompletionDialog}>
                确定
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 结算页 - 使用游戏背景，不添加遮罩 */}
      {showSettlement && (
        <div className="settlement-page-no-overlay">
          <div className="settlement-container-no-overlay">
            {/* 左中右三块布局 */}
            <div className="settlement-three-columns">
              {/* 左侧：选手1 */}
              <div className="settlement-left-column">
                <div className="settlement-player-section">
                  <div className="settlement-player-header-box">
                    <div className="settlement-player-avatar-large">
                      <img src={pkAvatar} alt="选手1头像" />
                    </div>
                    {(winner === 'left' || winner === 'tie') && (
                      <img src={crownImage} alt="皇冠" className="settlement-crown" />
                    )}
                    <div className="settlement-player-name-large">大鱼先锋队</div>
                  </div>
                  <div className="settlement-player-stats">
                    <div 
                      className="settlement-stat-item"
                      style={{
                        background: `linear-gradient(to left, rgba(${leftStatGradient.r}, ${leftStatGradient.g}, ${leftStatGradient.b}, ${leftStatGradient.opacity}), rgba(${leftStatGradient.r}, ${leftStatGradient.g}, ${leftStatGradient.b}, 0))`
                      }}
                    >
                      <span className="settlement-stat-label">得分：</span>
                      <span className="settlement-stat-value">{leftScore}分</span>
                    </div>
                    <div 
                      className="settlement-stat-item"
                      style={{
                        background: `linear-gradient(to left, rgba(${leftStatGradient.r}, ${leftStatGradient.g}, ${leftStatGradient.b}, ${leftStatGradient.opacity}), rgba(${leftStatGradient.r}, ${leftStatGradient.g}, ${leftStatGradient.b}, 0))`
                      }}
                    >
                      <span className="settlement-stat-label">准度：</span>
                      <span className="settlement-stat-value">
                        {questions.length > 0 ? `${Math.round((leftAnswerRecords.filter(r => r.isCorrect).length / questions.length) * 100)}%` : '0%'}
                      </span>
                    </div>
                  </div>
                </div>
                
                {/* 比赛记录表格 */}
                <div className="settlement-records-table">
                  <div className="settlement-records-header">
                    <div>题目</div>
                    <div>我的战绩</div>
                  </div>
                  <div className="settlement-records-scroll">
                    <table className="settlement-table">
                      <tbody>
                        {leftAnswerRecords.map((record, index) => {
                          // 确定行的类名：答对且得分、答对但没得分（慢了）、答错
                          let rowClassName = 'wrong-row';
                          if (record.isCorrect) {
                            rowClassName = record.gotScore ? 'correct-row' : 'slow-correct-row';
                          }
                          
                          // 确定图标：得分✓、慢了🐌、错误✗
                          let icon = '✗';
                          if (record.isCorrect) {
                            icon = record.gotScore ? '✓' : '🐌';
                          }
                          
                          return (
                            <tr key={index} className={rowClassName}>
                              <td>{record.question?.word?.title || record.question?.question || ''}</td>
                              <td className="settlement-result-cell">
                                {icon}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* 中间：操作按钮 */}
              <div className="settlement-center-column">
                <img src={settlementImage} alt="结算装饰" className="settlement-center-image" />
                <div className="settlement-actions">
                  <button 
                    className="settlement-btn settlement-btn-primary settlement-btn-image" 
                    onClick={handleReset}
                    style={{ backgroundImage: `url(${retryButtonImage})` }}
                  >
                    再战一次
                  </button>
                  <button 
                    className="settlement-btn settlement-btn-secondary settlement-btn-image" 
                    onClick={handleFinish}
                    style={{ backgroundImage: `url(${completeButtonImage})` }}
                  >
                    完成
                  </button>
                </div>
              </div>

              {/* 右侧：选手2 */}
              <div className="settlement-right-column">
                <div className="settlement-player-section">
                  <div className="settlement-player-header-box">
                    <div className="settlement-player-avatar-large">
                      <img src={pkAvatar} alt="选手2头像" />
                    </div>
                    {(winner === 'right' || winner === 'tie') && (
                      <img src={crownImage} alt="皇冠" className="settlement-crown" />
                    )}
                    <div className="settlement-player-name-large">大鱼破浪队</div>
                  </div>
                  <div className="settlement-player-stats">
                    <div 
                      className="settlement-stat-item"
                      style={{
                        background: `linear-gradient(to right, rgba(${rightStatGradient.r}, ${rightStatGradient.g}, ${rightStatGradient.b}, ${rightStatGradient.opacity}), rgba(${rightStatGradient.r}, ${rightStatGradient.g}, ${rightStatGradient.b}, 0))`
                      }}
                    >
                      <span className="settlement-stat-label">得分：</span>
                      <span className="settlement-stat-value">{rightScore}分</span>
                    </div>
                    <div 
                      className="settlement-stat-item"
                      style={{
                        background: `linear-gradient(to right, rgba(${rightStatGradient.r}, ${rightStatGradient.g}, ${rightStatGradient.b}, ${rightStatGradient.opacity}), rgba(${rightStatGradient.r}, ${rightStatGradient.g}, ${rightStatGradient.b}, 0))`
                      }}
                    >
                      <span className="settlement-stat-label">准度：</span>
                      <span className="settlement-stat-value">
                        {questions.length > 0 ? `${Math.round((rightAnswerRecords.filter(r => r.isCorrect).length / questions.length) * 100)}%` : '0%'}
                      </span>
                    </div>
                  </div>
                </div>
                
                {/* 比赛记录表格 */}
                <div className="settlement-records-table">
                  <div className="settlement-records-header">
                    <div>题目</div>
                    <div>我的战绩</div>
                  </div>
                  <div className="settlement-records-scroll">
                    <table className="settlement-table">
                      <tbody>
                        {rightAnswerRecords.map((record, index) => {
                          // 确定行的类名：答对且得分、答对但没得分（慢了）、答错
                          let rowClassName = 'wrong-row';
                          if (record.isCorrect) {
                            rowClassName = record.gotScore ? 'correct-row' : 'slow-correct-row';
                          }
                          
                          // 确定图标：得分✓、慢了🐌、错误✗
                          let icon = '✗';
                          if (record.isCorrect) {
                            icon = record.gotScore ? '✓' : '🐌';
                          }
                          
                          return (
                            <tr key={index} className={rowClassName}>
                              <td>{record.question?.word?.title || record.question?.question || ''}</td>
                              <td className="settlement-result-cell">
                                {icon}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default RushAnswerGame;

